import HttpData from "@/http/data/http-data";

export interface IAccessControlDoorData {
    device_id: number;
    door_id: number;
    name: string;
    is_express_checkin_entrance: boolean;
}

export default class AccessControlDoorData extends HttpData {
    public device_id: number;
    public door_id: number;
    public name: string;
    public is_express_checkin_entrance: boolean;

    constructor(data: IAccessControlDoorData) {
        super();

        this.device_id = data.device_id;
        this.door_id = data.door_id;
        this.name = data.name;
        this.is_express_checkin_entrance = data.is_express_checkin_entrance;
    }
}
